import { Grid, Icon, Typography } from "@gupshup-frontend/gupshup-ts-components";

import {
  CALL_PERMISSION,
  TEMPLATE_PREVIEW_DATA_TESTID,
}                                 from "./constant";
import styles                     from "./style.module.css";

const CallPermissionRequest = () => {

  return (
    <Grid className = {styles.callPermissionPanel}>
      <Grid className = {styles.callPermissionIcon}>
        <Icon
          size   = {20}
          alt    = "Call permission Request Icon"
          name   = "phone"
          weight = "fill"
          color  = "var(--palette-common-black)"
        />
      </Grid>
      <Typography variant = "caption" fontWeight = {500} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.CALL_PERMISSION_HEADER}>
        {CALL_PERMISSION.MESSAGE}
      </Typography>
    </Grid>
  );
};

export default CallPermissionRequest;
